// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1hxuc","vLegacy":"SelectSecondary_vLegacy__y6p4E","error":"SelectSecondary_error__3O46z","disabled":"SelectSecondary_disabled__1eDya"};